<div class="flex flex-col h-full">
    <div class="flex flex-wrap-reverse gap-4 mb-4">
        <!-- Left Header Buttons (Customer, Task, Preview, ...)-->
        <div class="preview-button-container" [style.margin-left]="(IsMobile$ | async) ? '1.0rem' : '3.5rem'">
            <div class="commission-theme theme-override" *ngIf="(InvoiceFormGroupRawValues$ | async).CommissionId as commission">
                <a app-button class="wide-button" [matTooltip]="cls.getSingle$('Commission') | async" [attr.aria-label]="cls.getSingle$('Commission') | async" [routerLink]="['/', CommissionMeta.Path, commission.Id]"
                ><fa-icon [icon]="CommissionMeta.Icon"></fa-icon
                ></a>
                <span class="ml-2">{{commission.GetDisplayName()}}</span>
            </div>
            <div class="admin-theme theme-override" *ngIf="(InvoiceFormGroupRawValues$ | async).Customer?.Id as id">
                <a app-button class="wide-button" [matTooltip]="cls.getSingle$('CustomerSupplier') | async" [attr.aria-label]="cls.getSingle$('CustomerSupplier') | async" [routerLink]="['/', CustomerAdministrationMeta.Path, id]"
                ><fa-icon [icon]="CustomerAdministrationMeta.Icon"></fa-icon
                ></a>
            </div>
            <ng-container *ngIf="(LedgerImport$ | async) as ledgerImport">
                <div class="{{ TaskPageMeta.Theme }} theme-override" *ngIf="ledgerImport.EventIds?.length > 0">
                    <ng-container *ngFor="let id of ledgerImport.EventIds">
                        <button style="margin-right: 1rem;" app-button class="wide-button" (click)="onOpenEventClick(id)" [matTooltip]="'Aufgabe'">
                            <fa-icon [icon]="TaskPageMeta.Icon"></fa-icon>
                        </button>
                    </ng-container>
                </div>
            </ng-container>
            <button app-round-button *ngIf="(LedgerImport$ | async)?.DocumentId as documentId" (click)="openLedgerImportDocument()" matTooltip="Dokument"><fa-icon [icon]="DMSPageMeta.Icon"></fa-icon></button>
            <button app-button  *ngIf="previewCard !== 'pdf'" (click)="previewCard = 'pdf'">Vorschau</button>
            <button app-button  *ngIf="previewCard !== 'calculation' && (partner$ | async)?.AdditionalData?.invoiceEditorCalculation" (click)="previewCard = 'calculation'">Kalkulation</button>
            <button app-button   (click)="openRequirementTable()">Bedarf</button>
        </div>
        <!-- Right Header Buttons (Save, Delete, Download, ...) -->
        <app-top-button-wrapper class="ml-auto">
            <!--        <div class="button-wrapper">-->
            <!--            <app-burger-button-wrapper class="editor-button-wrapper" [BurgerButtonMargin]="false">-->
            <app-detail-list-template [class.hide]="!ShowStatus" [Inline]="true" [Editing]="(DisableAllChanges$ | async) === false" [Data]="StatusData$ | async"></app-detail-list-template>
            <button class="detail-view-buttons" [Disabled]="DisableAllChanges$ | async" Inverted app-round-button [Active]="ShowStatus" (click)="onToggleStatusClick()" matTooltip="Status ändern" aria-label="Status ändern" [IsLoading]="LS.IsLoading$ | async">
                <fa-icon [icon]="ShowStatus ? 'chevron-right' : 'info'"></fa-icon>
            </button>
            <button *ngIf="InfoiceFormGroup.controls.IsLvCalculated.value" class="detail-view-buttons" Inverted app-round-button matTooltip="Preisspiegel" (click)="onPriceCompairsonClick()"><fa-icon [icon]="'down-left-and-up-right-to-center'"></fa-icon></button>
            <button class="detail-view-buttons" Inverted app-round-button (click)="SaveClick()" matTooltip="Speichern" aria-label="Speichern" [IsLoading]="LS.IsLoading$ | async" Color="green" [Disabled]="(nothingDirty$ | async) || (DisableAllChanges$ | async)">
                <fa-icon icon="save"></fa-icon>
            </button>
            <button class="detail-view-buttons" Inverted app-round-button matTooltip="Löschen" aria-label="Löschen" Color="red" *ngIf="ShowDeleteButton$ | async" (click)="OpenDeleteDialog$.next()" [Disabled]="DisableAllChanges$ | async">
                <fa-icon icon="trash"></fa-icon>
            </button>
            <!--        1{{InfoiceFormGroup.dirty}}-->
            <!--        2{{(SfdtIsDirty$ | async)}}-->
            <!--        3{{arlTableComponent?.SomeFormDirty$ | async}}-->
            <mat-menu #documentTypeMenu>
                <button mat-menu-item *ngFor="let d of LiDocTypeOptions" (click)="CreateDocument(d.type)">{{ d.label }}</button>
            </mat-menu>
            <button class="detail-view-buttons" Inverted app-round-button matTooltip="Herunterladen" aria-label="Herunterladen" *ngIf="(LedgerImport$ | async)?.IsTemplate !== true" [matMenuTriggerFor]="downloadMenu">
                <fa-icon icon="download"></fa-icon>
            </button>
            <button class="detail-view-buttons" Inverted app-round-button matTooltip="E-Mail senden" aria-label="E-Mail senden" [matMenuTriggerFor]="emailMenu" [IsLoading]="LS.IsLoading$ | async">
                <fa-icon icon="paper-plane"></fa-icon>
            </button>
            <button
                class="detail-view-buttons"
                [Disabled]="!(this.LedgerImport$ | async)?.AccountsReceivableLedgerIds?.length || (DisableAllChanges$ | async)"
                (click)="onCreateCommissionClick()"
                *ngIf="(LedgerImport$ | async)?.CommissionId === null"
                Inverted
                app-round-button
                [matTooltip]="(cls.getSingle$('Commission') | async) + ' anlegen'"
                [attr.aria-label]="(cls.getSingle$('Commission') | async) + ' anlegen'"
            >
                <app-double-icon Icon2="plus" [Icon]="CommissionMeta.Icon"></app-double-icon>
            </button>
            <button
                class="detail-view-buttons"
                [Disabled]="!(this.LedgerImport$ | async)?.AccountsReceivableLedgerIds?.length || (DisableAllChanges$ | async)"
                (click)="onAddToResToCommissionClick(commissionId)"
                *ngIf="(LedgerImport$ | async)?.CommissionId as commissionId"
                Inverted
                app-round-button
                [matTooltip]="'Ressourcen zu ' + (cls.getSingle$('Commission') | async) + ' hinzufügen'"
                [attr.aria-label]="'Ressourcen zu ' + (cls.getSingle$('Commission') | async) + ' hinzufügen'"
            >
                <app-double-icon Icon2="arrow-right" [Icon]="CommissionMeta.Icon"></app-double-icon>
            </button>
            <button class="detail-view-buttons" Inverted app-round-button matTooltip="Wiedervorlage erstellen" aria-label="Wiedervorlage erstellen" *ngIf="!(LedgerImport$ | async)?.IsTemplate" (click)="CreateDocument('template')">
                <app-double-icon Icon="file-alt" Icon2="plus"></app-double-icon>
            </button>
            <button class="detail-view-buttons" Inverted app-round-button matTooltip="Dokument generieren" aria-label="Dokument generieren" [matMenuTriggerFor]="documentTypeMenu">
                <app-double-icon Icon="file-invoice-dollar" Icon2="plus"></app-double-icon>
            </button>
            <!--            <div class="dms-button-wrapper">-->
            <!--                <button-->
            <!--                    app-button-->
            <!--                    Lighter-->
            <!--                    class="wide-button"-->
            <!--                    *ngIf="LedgerImport$ | async as li"-->
            <!--                    [Disabled]="!li.DocumentId"-->
            <!--                    [routerLink]="['/', DMSPageMeta.Path]"-->
            <!--                    [queryParams]="{ documentId: li.DocumentId }"-->
            <!--                    matTooltip="Zum DMS"-->
            <!--                >-->
            <!--                    <fa-icon [icon]="DMSPageMeta.Icon"></fa-icon>-->
            <!--                </button>-->
            <!--            </div>-->
            <!--            </app-burger-button-wrapper>-->
            <mat-menu #downloadMenu="matMenu" style="margin: 0">

                <button mat-menu-item *ngIf="LedgerImport$ | async as li" (click)="onDownloadFileClick('pdf')" [disabled]="(DisableAllChanges$ | async) && (!li.DocumentCanBeDownloaded || !li.DocumentId)" matTooltip="PDF Herunterladen"><fa-icon icon="file-pdf" class="mr-2"></fa-icon> PDF</button>
<!--                <a mat-menu-item [href]="XInvoiceDownloadLink$ | async" [download]="GetFilename(InfoiceFormGroup.value.ConsolidatedInvoiceId)" matTooltip="X-Rechnung Herunterladen" *ngIf="XInvoiceDownloadLink$ | async">-->
<!--                    <fa-icon icon="file-excel" class="mr-2"></fa-icon> X-Rechnung-->
<!--                </a>-->
                <button mat-menu-item  (click)="onDownloadFileClick('xInvoice')" *ngIf="LedgerImport$ | async as li" [disabled]="(DisableAllChanges$ | async) && (!li.DocumentIdXRechnung)"  matTooltip="X-Rechnung Herunterladen"><fa-icon icon="file-excel" class="mr-2"></fa-icon> X-Rechnung</button>
<!--                <button mat-menu-item (click)="DownloadPdfWithoutFile$.next('xInvoice')" matTooltip="X-Rechnung Herunterladen"><fa-icon icon="file-excel" class="mr-2"></fa-icon> X-Rechnung</button>-->


                <ng-container *ngFor="let btn of visibleExportButtons$ | async">
                    <button mat-menu-item (click)="onExportGaebClick(btn.code)" [matTooltip]="btn.label + ' Herunterladen'">
                        <fa-icon icon="file" class="mr-2"></fa-icon>
                        {{ btn.label }}
                        <fa-icon icon="info-circle" [matTooltip]="btn.tooltip" size="lg"></fa-icon>
                    </button>
                </ng-container>

                <button *ngIf="(hiddenExportButtons$ | async)?.length > 0"
                        mat-menu-item [matMenuTriggerFor]="secondMenuGaebExport">
                    Andere Formate
                </button>


            </mat-menu>
            <mat-menu #secondMenuGaebExport="matMenu">
                <ng-template matMenuContent>
                    <ng-container *ngFor="let btn of hiddenExportButtons$ | async">
                        <button mat-menu-item
                                (click)="onExportGaebClick(btn.code)"
                                [matTooltip]="btn.label + ' Herunterladen'">
                            <fa-icon icon="file" class="mr-2"></fa-icon>
                            {{ btn.label }}
                            <fa-icon icon="info-circle" [matTooltip]="btn.tooltip" size="lg"></fa-icon>
                        </button>
                    </ng-container>
                </ng-template>
            </mat-menu>

            <mat-menu #emailMenu="matMenu" style="margin: 0">
                <button  mat-menu-item (click)="onOpenMailDialog('pdf')" *ngIf="LedgerImport$ | async as li" [disabled]="(DisableAllChanges$ | async) && (!li.DocumentCanBeDownloaded || !li.DocumentId)" matTooltip="als PDF senden"><fa-icon icon="file-pdf" class="mr-2"></fa-icon> PDF</button>
                <button mat-menu-item (click)="onOpenMailDialog('xRechnung')" *ngIf="LedgerImport$ | async as li" [disabled]="(DisableAllChanges$ | async) && (!li.DocumentIdXRechnung)" matTooltip="als X-Rechnung senden"><fa-icon icon="file-excel" class="mr-2"></fa-icon> X-Rechnung</button>
                <ng-container *ngFor="let btn of visibleExportButtons$ | async">
<!--                    warum hier runterladen und nicht mail öffnen ?-->
                    <button mat-menu-item (click)="onExportGaebClick(btn.code)" [matTooltip]="btn.label + ' Herunterladen'">
                        <fa-icon icon="file" class="mr-2"></fa-icon>
                        {{ btn.label }}
                        <fa-icon icon="info-circle" [matTooltip]="btn.tooltip" size="lg"></fa-icon>
                    </button>
                </ng-container>

                <button *ngIf="(hiddenExportButtons$ | async)?.length > 0"
                        mat-menu-item [matMenuTriggerFor]="secondMenuGaebMailExport">
                    Andere Formate
                </button>
                <!--            <button  *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.GaebXml || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('x83')" matTooltip="als X83 Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> X83 Datei</button>-->
                <!--            <button *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.GaebXml || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('x84')" matTooltip="als X84 Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> X84 Datei</button>-->
                <!--            <button *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.UglFT || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('ugl')" matTooltip="als UGL Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> UGL Datei</button>-->
                <!--            <button *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.OenormFT || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('onlv')" matTooltip="als onlv Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> Onlv Datei</button>-->
                <!--            <button *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.Gaeb2000 || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('p83')" matTooltip="als P83 Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> P83 Datei</button>-->
                <!--            <button *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.Gaeb2000 || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('p84')" matTooltip="als P84 Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> P84 Datei</button>-->
                <!--            <button *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.Gaeb90 || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('d83')" matTooltip="als D83 Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> D83 Datei</button>-->
                <!--            <button *ngIf="ledgerImport.GabeImportedType === LedgerImportGaebFileTypesEnum.Gaeb90 || ledgerImport.GabeImportedType === null" mat-menu-item (click)="onOpenMailDialog('d84')" matTooltip="als D84 Datei senden"><fa-icon icon="file" class="mr-2"></fa-icon> D84 Datei</button>-->
            </mat-menu>
            <mat-menu #secondMenuGaebMailExport="matMenu">
                <ng-template matMenuContent>
                    <ng-container *ngFor="let btn of hiddenExportButtons$ | async">
                        <button mat-menu-item
                                (click)="onOpenMailDialog(btn.code)"
                                [matTooltip]="'Als '+btn.label + ' senden'">
                            {{btn.label}}
                        </button>
                    </ng-container>
                </ng-template>
            </mat-menu>
        </app-top-button-wrapper>
    </div>
    <div class="wrapper grow flex gap-1 h-full box-border">
        <!-- das ist die mat-card mit rechnung bearbeiten-->
        <mat-card class="grow edit-invoice-wrapper p-0" [class.hide]="previewCard && (IsMobile$ | async) === true">
            <!--                <mat-card-header class="card-header">-->
            <!--                    -->
            <!--           </mat-card-header>-->
            <mat-card-content #formWrapper class="scroll-wrapper" id="editBillScreen" cdkScrollable>
<!--                <div class="cw-wrapper">-->
                <div class="card-header" style="width: 100%">
                    <fa-icon matCardAvatar [icon]="InvoiceEditorMeta.Icon"></fa-icon>
                    <h2 *ngIf="LedgerImport$ | async as ledgerImport" style="margin: 0">
                        {{ (ledgerImport.IsTemplate ? 'Vorlage für ' : '') + LedgerImportDocumentTypeNames.get(ledgerImport.DocumentType) }}
                        bearbeiten
                    </h2>
                    <!-- D277-5334 - Verschoben in den Header
                    <div *ngIf="(IsMobile$ | async)" class="mobile-header-buttons">
                        <div class="commission-theme theme-override" *ngIf="InfoiceFormGroup.getRawValue().CommissionId?.Id as id">
                            <a app-button class="wide-button" [matTooltip]="cls.getSingle$('Commission') | async" [attr.aria-label]="cls.getSingle$('Commission') | async" [routerLink]="['/', CommissionMeta.Path, id]"
                            ><fa-icon [icon]="CommissionMeta.Icon"></fa-icon
                            ></a>
                        </div>
                        <div class="admin-theme theme-override" *ngIf="InfoiceFormGroup.getRawValue().Customer?.Id as id">
                            <a app-button class="wide-button" [matTooltip]="cls.getSingle$('CustomerSupplier') | async" [attr.aria-label]="cls.getSingle$('CustomerSupplier') | async" [routerLink]="['/', CustomerAdministrationMeta.Path, id]"
                            ><fa-icon [icon]="CustomerAdministrationMeta.Icon"></fa-icon
                            ></a>
                        </div>
                        <ng-container *ngIf="(LedgerImport$ | async) as ledgerImport">
                            <div class="{{ TaskPageMeta.Theme }} theme-override" *ngIf="ledgerImport.EventIds?.length > 0">
                                <ng-container *ngFor="let id of ledgerImport.EventIds">
                                    <button style="margin-right: 1rem;" app-button class="wide-button" (click)="onOpenEventClick(id)" [matTooltip]="'Aufgabe'">
                                        <fa-icon [icon]="TaskPageMeta.Icon"></fa-icon>
                                    </button>
                                </ng-container>
                            </div>
                        </ng-container>
                        <button app-round-button  *ngIf="(LedgerImport$ | async)?.DocumentId as documentId" (click)="openFilePreview(documentId)" [matTooltip]="'Dokument'"><fa-icon [icon]="DMSPageMeta.Icon"></fa-icon></button>
                        <button app-button *ngIf="previewCard !== 'pdf'" (click)="previewCard = 'pdf'">Vorschau</button>
                        <button app-button *ngIf="previewCard !== 'calculation' && (partner$ | async)?.AdditionalData?.invoiceEditorCalculation" (click)="previewCard = 'calculation'">Kalkulation</button>
                    </div>
                    -->
                </div>
                <div class="invoice-info-editing-wrapper">
                    <mat-accordion multi>
                        <!--
                                                <app-detail-list-template class="p-0 my-4" [Inline]="false" [Editing]="true" [Data]="CustomerData | async"></app-detail-list-template>-->
                        <ng-container>
                            <mat-card class="my-4">
                                <mat-form-field style="width: 100%" aria-label="Kunde">
                                    <mat-label> {{customerLable}}</mat-label>
                                    <fa-icon
                                        matSuffix
                                        icon="times"
                                        style="margin-left: 3px; cursor: pointer"
                                        (click)="InfoiceFormGroup.controls.Customer.setValue(null); $event.stopPropagation()"
                                        *ngIf="!InfoiceFormGroup.controls.Customer.disabled"
                                    ></fa-icon>
<!--                                    <app-select-search-->
<!--                                        [formControl]="InfoiceFormGroup.controls.Customer"-->
<!--                                        [Options]="customerData.Properties[0].options.specialInput.singleSelectSearch.options"-->
<!--                                        [CompareOptions]="compareById"-->
<!--                                    ></app-select-search>-->



                                        <app-select-search-paged-options
                                            #pagedSelect
                                            [formControl]="InfoiceFormGroup.controls.Customer"
                                            [Options]="customerSearch.customerOptions$ | async"
                                            [isLoading]="this.customerSearch.loading$ | async"
                                            [CompareOptions]="compareById"
                                            (searchChange)="this.customerSearch.SearchCustomers($event, 'unbenannter' + customerLable)"
                                        >
                                            <div search-bar-suffix *ngIf="customerSearch.customerData.defaultFilterSettings$ | async as customerFilterSettungs">
                                                <button mat-icon-button class="mat-badge-more-overlay" matBadgeSize="small" [matBadge]="customerSearch.filterValuesCount$ | async" (click)="filter.Open()"><fa-icon icon="filter"></fa-icon></button>
                                                <app-filter-card UnlimitedHeight #filter class="filter-right" [Settings]="customerFilterSettungs" [Values]="customerSearch.filterValues$ | async" (ValuesChange)="customerSearch.FilterCustomers($event)"></app-filter-card>
                                            </div>
                                            <mat-paginator
                                                option-list-footer
                                                #paginator
                                                [pageSize]="50"
                                                [length]="(this.customerSearch.customerPaging.pageCount$ | async) * paginator.pageSize"
                                                [pageIndex]="this.customerSearch.customerPaging.pageIndex$ | async"
                                                (page)="this.customerSearch.customerPageChange($event)"
                                            >
                                            </mat-paginator>
                                        </app-select-search-paged-options>
                                    </mat-form-field>
                            </mat-card>
                        </ng-container>
<!--                        <mat-card class="my-4">-->
<!--                            -->
<!--                        </mat-card>-->

                        <!--                            <mat-form-field>-->
                        <!--                                <app-select-search placeholder="Adressen durchsuchen" (selectionChange)="selectionChange($event)" [Options]="SearchAddressOptions" [CompareOptions]="compareOptions" [SearchFunction]="searchFunction"></app-select-search>-->
                        <!--                            </mat-form-field>-->
                        <mat-expansion-panel (opened)="recipientPanelOpened()">
                            <mat-expansion-panel-header>
                                <mat-panel-title> Empfänger Details </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-form-field style="width: 100%" aria-label="Kunde">
                                <mat-label>Aus {{cls.getMultiple$('Customer') | async}} suchen</mat-label>
<!--                                <fa-icon-->
<!--                                    matSuffix-->
<!--                                    icon="times"-->
<!--                                    style="margin-left: 3px; cursor: pointer"-->
<!--                                    (click)="InfoiceFormGroup.controls.Customer.setValue(null); $event.stopPropagation()"-->
<!--                                    *ngIf="!InfoiceFormGroup.controls.Customer.disabled"-->
<!--                                ></fa-icon>-->
                                <app-select-search-paged-options
                                    #pagedSelect
                                    [formControl]="recipientCustomerForm"
                                    [Options]="customerSearchForReciplintData.customerOptions$ | async"
                                    [isLoading]="this.customerSearchForReciplintData.loading$ | async"
                                    [CompareOptions]="compareById"
                                    (searchChange)="this.customerSearchForReciplintData.SearchCustomers($event, 'unbenannter' + customerLable)"
                                >
                                    <div search-bar-suffix *ngIf="customerSearchForReciplintData.customerData.defaultFilterSettings$ | async as customerFilterSettungs">
                                        <button mat-icon-button class="mat-badge-more-overlay" matBadgeSize="small" [matBadge]="customerSearchForReciplintData.filterValuesCount$ | async" (click)="filter.Open()"><fa-icon icon="filter"></fa-icon></button>
                                        <app-filter-card UnlimitedHeight #filter class="filter-right" [Settings]="customerFilterSettungs" [Values]="customerSearchForReciplintData.filterValues$ | async" (ValuesChange)="customerSearchForReciplintData.FilterCustomers($event)"></app-filter-card>
                                    </div>
                                    <mat-paginator
                                        option-list-footer
                                        #paginator
                                        [pageSize]="50"
                                        [length]="(this.customerSearchForReciplintData.customerPaging.pageCount$ | async) * paginator.pageSize"
                                        [pageIndex]="this.customerSearchForReciplintData.customerPaging.pageIndex$ | async"
                                        (page)="customerSearchForReciplintData.customerPageChange($event)"
                                    >
                                    </mat-paginator>
                                </app-select-search-paged-options>
                            </mat-form-field>
                            <mat-form-field *ngIf="recipientPersonData$ | async as persons" style="width: 100%">
                                <mat-label>Aus Kontakte suchen</mat-label>
<!--                                <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer" (click)="this.recipientPersonForm.setValue(null); $event.stopPropagation()" *ngIf="!this.recipientPersonForm.disabled"></fa-icon>-->
                                <app-select-search [formControl]="this.recipientPersonForm" [Options]="persons" [CompareOptions]="compareById">
                                    <div search-bar-suffix>
                                        <button
                                            *ngIf="!InfoiceFormGroup.value.Customer && !InfoiceFormGroup.value.CommissionId"
                                            mat-icon-button
                                            class="mat-badge-more-overlay"
                                            matBadgeSize="small"
                                            [matBadge]="personFilterCount$ | async"
                                            (click)="filter.Open()"
                                        >
                                            <fa-icon icon="filter"></fa-icon>
                                        </button>
                                        <app-filter-card UnlimitedHeight #filter [Settings]="personFilterSettings$ | async" [Values]="personFilterValues$ | async" (ValuesChange)="personFilterValues$.next($event)"></app-filter-card>
                                    </div>
                                </app-select-search>
                            </mat-form-field>
                            <app-detail-list-template [Inline]="true" [Editing]="true" [Data]="AddressFormData"></app-detail-list-template>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title> Notiz </mat-panel-title>
                            </mat-expansion-panel-header>
                            <app-detail-list-template [Inline]="true" [Editing]="true" [Data]="NotesFormData"></app-detail-list-template>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title> Lieferadresse Details </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-checkbox [ngModel]="InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.value" (change)="onCheckboxChange($event)" [disabled]="(InvoiceFormGroupRawValues$ | async)?.CommissionId === null || (DisableAllChanges$ | async)">Lieferadresse des {{cls.getSingle$('Commission', 'Genitiv') | async}} verwenden</mat-checkbox>
                            <app-detail-list-template [Inline]="true" [Editing]="true" [Data]="DeliveryAddressFormData"></app-detail-list-template>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <mat-accordion multi>
                        <mat-card class="my-4">
                            <mat-form-field *ngIf="(PartnerOfficeData$ | async)?.Properties[0].options.specialInput.singleSelectSearch.options as options" style="width: 100%">
                                <mat-label>Unternehmen</mat-label>
                                <fa-icon
                                    matSuffix
                                    icon="times"
                                    style="margin-left: 3px; cursor: pointer"
                                    (click)="InfoiceFormGroup.controls.PartnerOffice.setValue(null); $event.stopPropagation()"
                                    *ngIf="!InfoiceFormGroup.controls.PartnerOffice.disabled"
                                ></fa-icon>
                                <app-select-search [disabled]="InfoiceFormGroup.value.Customer !== null" [formControl]="InfoiceFormGroup.controls.PartnerOffice" [Options]="options" [CompareOptions]="compareById"> </app-select-search>
                            </mat-form-field>
                        </mat-card>

                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title> Absender Details </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div style="position: relative; width: 200px">
                                <button app-round-button style="position: absolute; top: 0.5rem; right: 0.5rem" (click)="logoUpload.click()" [Disabled]="DisableArlForms$ | async">
                                    <fa-icon icon="upload"></fa-icon>
                                </button>

                                <img *ngIf="LogoUrl$ | async as logoUrl" [src]="logoUrl" style="width: 200px" />
                                <div
                                    *ngIf="!(LogoUrl$ | async)"
                                    style="width: 200px; height: 150px; display: flex; align-items: center; justify-content: center; flex-direction: column; border-radius: 4px; background-color: rgba(0, 0, 0, 0.15)"
                                >
                                    <fa-icon icon="camera" size="3x"></fa-icon>
                                    <h2 style="margin: 0">Logo</h2>
                                </div>
                                <input id="file" type="file" accept="image/*" hidden #logoUpload (change)="OnFileChange($event)" />
                            </div>
                            <app-detail-list-template [Inline]="true" [Editing]="true" [Data]="PartnerDetailData"></app-detail-list-template>
                        </mat-expansion-panel>
                        <app-detail-list-template class="p-0 py-4" [Inline]="false" [Editing]="true" [Data]="AssignedEmployeeData | async"></app-detail-list-template>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title> Bearbeiter Details </mat-panel-title>
                            </mat-expansion-panel-header>
                            <app-detail-list-template [Inline]="true" [Editing]="true" [Data]="UserDetailData"></app-detail-list-template>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title> Allgemeine Details </mat-panel-title>
                                <mat-panel-description *ngIf="(InvoiceFormGroupRawValues$ | async)?.CommissionId as commission">{{cls.getSingle$('Commission') | async}}: {{commission.GetDisplayName()}}</mat-panel-description>
                            </mat-expansion-panel-header>
                            <app-detail-list-template [Inline]="true" [Editing]="true" [Data]="FormData | async"></app-detail-list-template>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <mat-card style="width: 100%">
                    <app-textfield Key="Titel" [Value]="InfoiceFormGroup.controls.Title"></app-textfield>
                    <div #wrapper class="textarea-with-template-button">
                        <app-textarea [Fill]="true" Key="Text über Buchungstabelle" [Value]="InfoiceFormGroup.controls.TextTop"></app-textarea>
                        <button class="template-button" app-round-button
                                (mousedown)="$event.preventDefault()"
                                (click)="insertTemplate(InfoiceFormGroup.controls.TextTop, wrapper.querySelector('textarea'))"
                                matTooltip="Vorlage einfügen">
                            <fa-icon icon="file-lines"></fa-icon>
                        </button>
                    </div>
                </mat-card>
                <span id="scrollAnker"></span>
                <div id="arlTableHeader" class="mat-card table-header"
                     style="z-index: 101; padding:8px; box-shadow: 0px -2px 1px -1px rgba(0, 0, 0, 0.2), 0px 0px 1px 0px rgba(0, 0, 0, 0.14), 0px -1px 3px 0px rgba(0, 0, 0, 0.12)">
                    <mat-card-header class="card-header">
                        <fa-icon matCardAvatar [icon]="BookingPositionMetaIcon"></fa-icon>
                        <div class="title-shortener-workaround">
                            <h3 mat-card-title style="min-width: 0vw">Abr.-Pos.</h3>
                        </div>
                        <button class="mx-4" *ngIf="(PS.Has$(PS.Permissions.ChangeLedgerImports) | async)"
                                [disabled]="(disableGaebRelevantForms$ | async) || (DisableArlForms$ | async)"
                                app-round-button (click)="$event.stopPropagation()"
                                [matMenuTriggerFor]="menuArlTableOptions" matTooltip="Dokument Anpassen">
                            <fa-icon icon="ellipsis-vertical"></fa-icon>
                        </button>

                        <mat-menu #menuArlTableOptions="matMenu" class="auto-content-menu">
                            <div mat-menu-item>
                                <mat-slide-toggle class="mx-4" [disabled]="DisableArlForms$ | async"
                                                  [formControl]="InfoiceFormGroup.controls.ShowNettoSum">Summe Netto
                                    Anzeigen
                                </mat-slide-toggle>
                            </div>
                            <div mat-menu-item>
                                <mat-slide-toggle class="mx-4" [disabled]="DisableArlForms$ | async"
                                                  [formControl]="InfoiceFormGroup.controls.ArlTableStartOnNewPage">
                                    Buchungstabelle auf neuer Seite starten
                                </mat-slide-toggle>
                            </div>
                            <div mat-menu-item>
                                <mat-slide-toggle
                                    class="mx-4"
                                    [disabled]="DisableArlForms$ | async"
                                    [formControl]="InfoiceFormGroup.controls.ShowTaxSum"
                                >
                                    Enthaltene MwSt ausweisen
                                </mat-slide-toggle>
                            </div>
                            <div *ngIf="isLuksch$ | async" mat-menu-item>
                                <mat-slide-toggle class="mx-4" [formControl]="InfoiceFormGroup.controls.HideLetterHead">
                                    Briefkopf ausblenden
                                </mat-slide-toggle>
                            </div>
                            <div mat-menu-item>
                                <mat-slide-toggle class="mx-4" [formControl]="InfoiceFormGroup.controls.HideSumTable">
                                    Summen ausblenden
                                </mat-slide-toggle>
                            </div>
                            <div mat-menu-item>
                                <mat-slide-toggle class="mx-4" [formControl]="InfoiceFormGroup.controls.HidePositionsWithoutQuantity">
                                    0 Mengen ausblenden
                                </mat-slide-toggle>
                            </div>
                            <div mat-menu-item class="flex gap-2 items-center mx-4">
                                <mat-slide-toggle [disabled]="DisableArlForms$ | async"
                                                  [formControl]="InfoiceFormGroup.controls.ShowLongInformation">
                                    Lang{{ (isLvCalculated$ | async) ? '-LV' : 'dokument' }}
                                </mat-slide-toggle>
                                <app-hint-icon
                                    hint="Alle Langtexte werden im Dokument angezeigt / ausgeblendet"></app-hint-icon>
                            </div>

                            <mat-divider></mat-divider>

                            <div mat-menu-item>
                                <mat-slide-toggle
                                    class="mx-4"
                                    [disabled]="DisableArlForms$ | async"
                                    [formControl]="InfoiceFormGroup.controls.ItemNumbersLocked"
                                >
                                    Positionsnummern einfrieren
                                </mat-slide-toggle                                >
                            </div>

                            <mat-divider></mat-divider>
                            <div mat-menu-item
                                 *ngIf="(invoiceEditorUseSalaryQuantityTypeSwitch$ | async) && !(isLvCalculated$ | async)">
                                <span class="font-bold">Einheit für Löhne</span>
                                <mat-button-toggle-group
                                    multiple
                                    (change)="onToggleEmployeeQuantityTypeChange($event); arlTableComponent.onEmployeeQuantityTypeChange(InfoiceFormGroup.value.EmployeeQuantityTypeId)"
                                    name="employeeQuantityType"
                                    [ngModel]="InfoiceFormGroup.value.EmployeeQuantityTypeId ? [InfoiceFormGroup.value.EmployeeQuantityTypeId] : []"
                                    [disabled]="DisableArlForms$ | async"
                                >
                                    <mat-button-toggle [value]="qt.Id"
                                                       *ngFor="let qt of employeeQuantityTypes$ | async">{{ qt.LangerName }}
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                            <div mat-menu-item>
                                <span class="font-bold">Seitenumbruch</span>
                                <mat-button-toggle-group
                                    [formControl]="InfoiceFormGroup.controls.BreakPageMode"
                                    [disabled]="DisableArlForms$ | async"
                                >
                                    <mat-button-toggle [value]="null">keine</mat-button-toggle>
                                    <mat-button-toggle [value]="LedgerImportBreakPageModeEnum.All">alle</mat-button-toggle>
                                    <mat-button-toggle [value]="LedgerImportBreakPageModeEnum.Title">Titel</mat-button-toggle>
                                    <mat-button-toggle [value]="LedgerImportBreakPageModeEnum.FirstLayerTitle">Titel erster Ebene</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </mat-menu>
                        <mat-form-field class="grow mr-4">
                            <mat-label>Suche nach Positionen</mat-label>
                            <input type="text" [ngModel]="''"
                                   (ngModelChange)="arlSearchQuery = $event;"
                                   matInput #arlSearchinput/>
                            <button class="small-icon-btn" matSuffix
                                    (click)="arlSearchinput.value = ''; arlSearchQuery = '';"
                                    mat-icon-button *ngIf="arlSearchinput.value">
                                <fa-icon icon="times"></fa-icon>
                            </button>
                        </mat-form-field>
<!--                        <div class="flex gap-4 mx-4 items-center"-->
<!--                             *ngIf="(invoiceEditorUseSalaryQuantityTypeSwitch$ | async) && !(isLvCalculated$ | async)">-->
<!--                            <span class="font-bold">Einheit für Löhne</span>-->
<!--                            <mat-button-toggle-group-->
<!--                                multiple-->
<!--                                (change)="onToggleEmployeeQuantityTypeChange($event); arlTableComponent.onEmployeeQuantityTypeChange(InfoiceFormGroup.value.EmployeeQuantityTypeId)"-->
<!--                                name="employeeQuantityType"-->
<!--                                [ngModel]="InfoiceFormGroup.value.EmployeeQuantityTypeId ? [InfoiceFormGroup.value.EmployeeQuantityTypeId] : []"-->
<!--                                [disabled]="DisableArlForms$ | async"-->
<!--                            >-->
<!--                                <mat-button-toggle [value]="qt.Id"-->
<!--                                                   *ngFor="let qt of employeeQuantityTypes$ | async">{{ qt.LangerName }}-->
<!--                                </mat-button-toggle>-->
<!--                            </mat-button-toggle-group>-->
<!--                        </div>-->
<!--                        <div class="flex gap-4 mx-4 items-center">-->
<!--                            <span class="font-bold">Seitenumbruch</span>-->
<!--                            <mat-button-toggle-group-->
<!--                                [formControl]="InfoiceFormGroup.controls.BreakPageMode"-->
<!--                                [disabled]="DisableArlForms$ | async"-->
<!--                            >-->
<!--                                <mat-button-toggle [value]="null">keine</mat-button-toggle>-->
<!--                                <mat-button-toggle [value]="LedgerImportBreakPageModeEnum.All">alle</mat-button-toggle>-->
<!--                                <mat-button-toggle [value]="LedgerImportBreakPageModeEnum.Title">Titel-->
<!--                                </mat-button-toggle>-->
<!--                                <mat-button-toggle [value]="LedgerImportBreakPageModeEnum.FirstLayerTitle">Titel erster-->
<!--                                    Ebene-->
<!--                                </mat-button-toggle>-->
<!--                            </mat-button-toggle-group>-->
<!--                        </div>-->
                        <!--                            <button mat-stroked-button [mat-menu-trigger-for]="pageBreakMenu">Seitenumbruch</button>-->
                        <!--                            <mat-menu #pageBreakMenu>-->
                        <!--                                <button mat-menu-item (click)="setNewLineMode('all')"><fa-icon [icon]="'check'" mat-list-icon></fa-icon> alle Positionen auf einer Neuen Seite</button>-->
                        <!--                                <button mat-menu-item (click)="setNewLineMode('title')">alle Titel auf einer Neuen Seite</button>-->
                        <!--                                <button mat-menu-item (click)="setNewLineMode('first-layer-title')">alle Titel erster Ebene auf einer Neuen Seite</button>-->
                        <!--                            </mat-menu>-->
                        <div class="header-button-wrapper flex gap-4 items-center">
                            <ng-container *ngIf="LedgerImport$ | async as ledgerImport">
                                <div *ngIf="
                        ledgerImport.DocumentType === LedgerImportDocumentTypesEnum.Order ||
                        ledgerImport.DocumentType === LedgerImportDocumentTypesEnum.OrderConfirmation ||
                        ledgerImport.DocumentType === LedgerImportDocumentTypesEnum.ReturnDeliveryNote ||
                        ledgerImport.DocumentType === LedgerImportDocumentTypesEnum.DeliveryNote
                      ">
                                    <span class="mat-body-2">Preise = Kosten </span>
                                    <app-hint-icon
                                        hint="Bei Bestellungen, Bestellbestätigungen, Lieferscheinen und Retourlieferscheinen, werden die Kosten automatisch gleich dem Preis gesetzt und der Preis gleich der Kosten (keine Kalkulation)"></app-hint-icon>
                                </div>
                            </ng-container>
                            <div class="flex gap-2 items-center" *ngIf="!(isLvCalculated$ | async)">
                                <mat-slide-toggle [formControl]="InfoiceFormGroup.controls.UseListPriceForNewMaterials">
                                    LP setzen
                                </mat-slide-toggle>
                                <app-hint-icon
                                    hint="Neue Materialien werden mit dem Listenpreis anstelle des Verkaufspreises hinzugefügt"></app-hint-icon>
                            </div>
                            <button *ngIf="!(isLvCalculated$ | async)" (click)="toggleArlMultiselect()" app-round-button
                                    [Disabled]="DisableArlForms$ | async">
                                <fa-stack>
                                    <fa-icon icon="check-square" stackItemSize="1x"></fa-icon>
                                    <fa-icon icon="slash" stackItemSize="1x" *ngIf="arlMultiselectActive"></fa-icon>
                                </fa-stack>
                            </button>
                            <button *ngIf="(PS.Has$(PS.Permissions.CreateLedgerImports) | async)"
                                    [Disabled]="(disableGaebRelevantForms$ | async) || (DisableArlForms$ | async)"
                                    app-round-button (click)="ReSortArls()" matTooltip="Pos. Nummern neu vergeben">
                                <fa-icon icon="arrows-up-down"></fa-icon>
                            </button>
                            <button
                                *ngIf="(PS.Has$(PS.Permissions.CreateLedgerImports) | async) && !(isLvCalculated$ | async)"
                                [Disabled]="(disableGaebRelevantForms$ | async) || (DisableArlForms$ | async)"
                                app-round-button (click)="NewBookingPositionClick$.next()"
                                matTooltip="Abr.-Pos. hinzufügen">
                                <app-double-icon Icon="money-bill" Icon2="plus"></app-double-icon>
                            </button>
                            <button
                                *ngIf="PS.Has$(PS.Permissions.CreateLedgerImports) | async"
                                [Disabled]="(disableGaebRelevantForms$ | async) || (DisableArlForms$ | async)"
                                [matMenuTriggerFor]="firstMenu"
                                [IsLoading]="ls.IsLoading$ | async"
                                app-round-button
                                matTooltip="Angebotsdatei (D83/P83/X83), Bieterdatei (D84/P84/X84), UGLdatei oder ONLVdatei einspielen"
                            >
                                <app-double-icon Icon="file-invoice" Icon2="plus"></app-double-icon>
                            </button>
                            <button app-round-button (click)="toggleLvCalculation()"
                                    [Disabled]="disableLVToggle$ | async" *ngIf="useLVCalculation$ | async">LV
                            </button>
                            <div *ngIf="(isLvCalculated$ | async)">
                                <button
                                    [Disabled]="!!arlSearchQuery"
                                    app-round-button
                                    (click)="lvFilter.Toggle(); $event.stopPropagation()"
                                    matTooltip="Filter"
                                >
                                    <fa-icon icon="filter"></fa-icon>
                                </button>
                                <app-filter-card UnlimitedHeight MaxWidthHundertPercent #lvFilter
                                                 [Settings]="LvFilterSettings$ | async"
                                                 [Values]="LvFilterValues$ | async"
                                                 (ValuesChange)="onFilterValuesChange($event)"></app-filter-card>
                            </div>
                        </div>

                        <mat-menu #firstMenu="matMenu" class="auto-content-menu">
                            <button mat-menu-item [matMenuTriggerFor]="secondMenu"
                                    [matMenuTriggerData]="{beShouldUpdateARLsFromGaebImport: this.BeShouldUpdateARLsFromGaebImport$ | async, fileFormat: 'X83'}"
                                    [disabled]="!(this.BeShouldUpdateARLsFromGaebImport$ | async)">
                                Angebotsdatei (D83/P83/X83) einspielen
                            </button>
                            <button mat-menu-item [matMenuTriggerFor]="secondMenu"
                                    [matMenuTriggerData]="{beShouldUpdateARLsFromGaebImport: this.BeShouldUpdateARLsFromGaebImport$ | async, fileFormat: 'X84'}">
                                Bieterdatei (D84/P84/X84) einspielen
                            </button>
                            <button mat-menu-item [matMenuTriggerFor]="secondMenu"
                                    [matMenuTriggerData]="{beShouldUpdateARLsFromGaebImport: this.BeShouldUpdateARLsFromGaebImport$ | async, fileFormat: 'UGL'}"
                                    [disabled]="!(this.BeShouldUpdateARLsFromGaebImport$ | async)">
                                UGLdatei einspielen
                            </button>
                            <button mat-menu-item [matMenuTriggerFor]="secondMenu"
                                    [matMenuTriggerData]="{beShouldUpdateARLsFromGaebImport: this.BeShouldUpdateARLsFromGaebImport$ | async, fileFormat: 'ONLV'}">
                                ONLVdatei einspielen
                            </button>
                        </mat-menu>

                        <mat-menu #secondMenu="matMenu">
                            <ng-template matMenuContent let-fileFormat="fileFormat"
                                         let-beShouldUpdateARLsFromGaebImport="beShouldUpdateARLsFromGaebImport">
                                <button mat-menu-item
                                        (click)="onSelectFileClick(fileFormat, beShouldUpdateARLsFromGaebImport)">Datei
                                    hinzufügen
                                </button>
                                <button mat-menu-item
                                        (click)="onUploadFileClick(fileFormat, beShouldUpdateARLsFromGaebImport)">Datei
                                    hochladen
                                </button>
                            </ng-template>
                        </mat-menu>
                    </mat-card-header>
                    <div class="flex flex-wrap">
                        <div
                            cdkDropList
                            [cdkDropListData]="addArlButtons$ | async"
                            id="arlTableDrag"
                            [cdkDropListConnectedTo]="[arlTableComponent?.tableDropList, arlLvCalculationComponent?.tableDropList]"
                            #addArlBtnDragList="cdkDropList"
                            [cdkDropListAutoScrollStep]="invoiceEditorAutoScrollSpeed"
                        >
                            <button
                                cdkDrag
                                mat-button
                                cdkDragPreviewContainer="parent"
                                class="grab-button"
                                [class.is-loading]="ls.IsLoading$ | async"
                                cdkDragPreviewClass="grabbing"
                                (cdkDragStarted)="onCdkDragStarted($event)"
                                (cdkDragEnded)="onCdkDragEnded($event)"
                                [cdkDragData]="b.type"
                                (click)="!this.InfoiceFormGroup.controls.IsLvCalculated.getRawValue() ? arlTableComponent.onClick(b.type) : {}"
                                *ngFor="let b of addArlButtons$ | async"
                                [disabled]="(DisableArlForms$ | async) || (disableGaebRelevantForms$ | async) || !!arlSearchQuery"
                            >
                            <span>
                                <fa-icon icon="bars" style="margin-right: 0.5rem"></fa-icon>
                                <span>{{ b.label }}</span>
                                <fa-icon [icon]="b.icon" style="margin-left: 0.5rem"></fa-icon>
                            </span>
                            </button>
                        </div>
                        <span style="padding: 0" class="grow"></span>
                        <button mat-icon-button [disabled]="DisableAllChanges$ | async" (click)="onLockClick()"
                                *ngIf="!(bs.MobileQuery | async)"
                                [matTooltip]="(disableGaebRelevantForms$ | async) ? 'Bearbeitung aktivieren' : 'Bearbeitung deaktivieren'">
                            <fa-icon
                                [icon]="(disableGaebRelevantForms$ | async) || (DisableAllChanges$ | async) ? 'lock' : 'lock-open'"></fa-icon>
                            &nbsp;
                            <app-hint-icon *ngIf="exportedFromGaeb$ | async"
                                           hint="Bearbeitung deaktiviert da die Positionen von einer GAEB-Datei importiert/exportiert wurden."></app-hint-icon>
                        </button>
                        <button mat-icon-button [disabled]="DisableAllChanges$ | async" (click)="openDrawer('table')"
                                *ngIf="!(bs.MobileQuery | async)" matTooltip="Tabelle anpassen">
                            <fa-icon
                                [icon]="(drawer?.opened && activeDrawerMode === 'table') ? 'times' : 'cog'"></fa-icon>
                        </button>

                        <button mat-icon-button [disabled]="DisableAllChanges$ | async" (click)="openDrawer('document')"
                                *ngIf="!(bs.MobileQuery | async)" matTooltip="Tabelle im Dokument anpassen">
                            <fa-icon
                                [icon]="(drawer?.opened && activeDrawerMode === 'document') ? 'times' : 'cog'"></fa-icon>
                        </button>
                    </div>


                    <ng-container
                        *ngIf="arlTableComponent && arlMultiselectActive && arlTableComponent.selectionData$ | async as selectionData">
                        <mat-divider></mat-divider>
                        <div class="flex px-4 items-center flex-wrap" id="arl-table-multiselect-row">
                            <span class="font-bold mr-2"><span
                                class="selection-counter">({{ arlTableComponent.selection.selected.length }})</span> Positionen ausgewählt</span>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectMarkOptional(true)"
                                    [disabled]="!selectionData.someCanBeOptional">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="signs-post"></fa-icon>
                                    <span>als optional markieren</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectMarkOptional(false)"
                                    [disabled]="!selectionData.someOptional">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="signs-post"></fa-icon>
                                    <span>optional markierung aufheben</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectMarkCrossedOut(true)"
                                    [disabled]="!selectionData.someCanBeCrossedOut">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="slash"></fa-icon>
                                    <span>durchstreichen</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectMarkCrossedOut(false)"
                                    [disabled]="!selectionData.someCrossedOut">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="slash"></fa-icon>
                                    <span>durchgestrichen aufheben</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectCopy()"
                                    [disabled]="!selectionData.canCopy">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="money-bill"></fa-icon>
                                    <span>kopieren</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectMarkFrozen(true)"
                                    [disabled]="!selectionData.someCanBeFrozen">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="snowflake"></fa-icon>
                                    <span>Preis einfrieren</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectMarkFrozen(false)"
                                    [disabled]="!selectionData.someFrozen">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="snowflake"></fa-icon>
                                    <span>Gefrorenen Preis aufheben</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectMerge()"
                                    [disabled]="!selectionData.canMerge">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="arrow-right-to-bracket"></fa-icon>
                                    <span>zusammenführen</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectSplit()"
                                    [disabled]="!selectionData.canSplit">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="arrow-right-from-bracket"></fa-icon>
                                    <span>sprengen</span>
                                </div>
                            </button>
                            <button class="my-1" mat-button (click)="arlTableComponent.multiselectDelete()"
                                    [disabled]="selectionData.empty" class="app-foreground-warn">
                                <div class="flex gap-2">
                                    <fa-icon class="mat-icon" icon="trash"></fa-icon>
                                    <span>löschen</span>
                                </div>
                            </button>
                        </div>
<!--                            <mat-divider></mat-divider>-->
                    </ng-container>
                </div>

                    <mat-card class="detail-list-card position-fix" id="arlTableContent" style="overflow: visible; width: 100%; max-height: unset; padding-top: 0; border-top-left-radius: 0; border-top-right-radius: 0">
<div class="mat-drawer-sticky-table-fix" id="arlTableFixWrapper">
                        <mat-drawer-container style="overflow: visible" class="drawer-container position-fix">
                            <mat-drawer mode="over" position="end" class="drawer-arl-table" #drawer (closed)="handleDrawerClosed()">

                                <ng-container *ngIf="activeDrawerMode === 'table'">
                                    <app-table-config-form #config [columns]="arlTableColumnConfig$ | async" [selectedColumns]="arlTableDisplayedColumns$ | async"></app-table-config-form>
                                </ng-container>

                                <ng-container *ngIf="activeDrawerMode === 'document'">
                                    <app-table-config-form #configDocument [columns]="arlTableColumnConfig$ | async" [selectedColumns]="arlTableDocumentDisplayedColumns$ | async"></app-table-config-form>
                                </ng-container>

                            </mat-drawer>
                            <mat-drawer-content class="card-background position-fix">
                                <ng-container *ngIf="(isLvCalculated$ | async)">
                                    <app-arl-lv-calculation
                                        #arlLvCalculationComponent
                                        [newArlBtnDragList]="addArlBtnDragList"
                                        [arlIds]="InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue()"
                                        (arlIdsChange)="updateArlIds($event)"
                                        (deleteClick)="onArlDeleteClick([$event.Id])"
                                        [ARLGlobalSurchargesByTypes]="InfoiceFormGroup.controls.ARLSurChargeByTypes.getRawValue()"
                                        [ARLCalculationPreChargeByTypes]="InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.getRawValue()"
                                        [globalPreCharge]="InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.getRawValue()"
                                        [surchargeForOther]="nkLvCalculationsurchargeNotSalary$ | async"
                                        [AddARLDefaultValues]="AddARLDefaultValues$ | async"
                                        [isOrder]="(LedgerImport$ | async)?.DocumentType === LedgerImportDocumentTypesEnum.Order"
                                        [disableReOrder]="disableGaebRelevantForms$ | async"
                                        [infoicePartieStd]="InfoiceFormGroup.controls.PartieStd.getRawValue()"
                                        (paginatorPage)="onLvPageEvent($event)"
                                        [ARLForm]="InfoiceFormGroup.controls.Arls"
                                        [LvFilterValues]="LvFilterValues$ | async"
                                        [itemNumbersLocked]="itemNumbersLocked$ | async"
                                        [searchQuery]="arlSearchQuery"
                                    ></app-arl-lv-calculation>
                                    <div class="flex gap-4 justify-between p-4 flex-wrap-reverse">
                                        <div class="flex flex-col">
                                            <h3>Zuschläge</h3>
                                            <mat-form-field *ngFor="let type of ARLSurChargeByTypesFormsVM$ | async">
                                                <input matInput [formControl]="type.controls.percentage" type="number" [placeholder]="ARLTypeEnumNames.get(type.value.arlType)" />
                                                <span matSuffix>%</span>
                                            </mat-form-field>
                                        </div>
                                        <app-nk-lv-calculation
                                            (surcharge)="nkLvCalculationsurchargeNotSalary$.next($event)"
                                            [otherZuschlag]="otherZuschlagForLV$ | async"
                                            [ledgerImportId]="(LedgerImport$ | async)?.Id"
                                            [LVKalkulationForm]="InfoiceFormGroup.controls.LVKalkulation"
                                        ></app-nk-lv-calculation>
                                    </div>
                                </ng-container>
                                <app-arl-table
                                    *ngIf="!(isLvCalculated$ | async)"
                                    [newArlBtnDragList]="addArlBtnDragList"
                                    [disabled]="(DisableArlForms$ | async) || (disableGaebRelevantForms$ | async)"
                                    [itemNumbersLocked]="itemNumbersLocked$ | async"
                                    #arlTableComponent
                                    [ARLCalculationPreChargeByTypes]="InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.getRawValue()"
                                    [aRLCalculationPreCharge]="InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.getRawValue()"
                                    [defaultSurcharges]="defaultSurcharges$ | async"
                                    [qTypesDict]="quantityTypeDictionary$ | async"
                                    [arlIds]="InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue()"
                                    (arlIdsChange)="updateArlIds($event)"
                                    [AddARLDefaultValues]="AddARLDefaultValues$ | async"
                                    (FormValueChange)="arlTableValuesChanged$.next()"
                                    (DeleteClick)="onArlDeleteClick($event)"
                                    [FilterMaterialsByCustomerId]="FilterMaterialsByCustomerId$ | async"
                                    [useArlSeparateSalaryBaseCost]="useArlSeparateSalaryBaseCost$ | async"
                                    [forceQuantityTypeIdForEmployeeArls]="InfoiceFormGroup.value.EmployeeQuantityTypeId"
                                    [liDocumentType]="(LedgerImport$ | async)?.DocumentType"
                                    [useListPriceForNewMaterials]="InfoiceFormGroup.value.UseListPriceForNewMaterials"
                                    [displayedColumns]="arlTableDisplayedColumns$ | async"
                                    [UseQuantityHistory]="InfoiceFormGroup.controls.UseQuantityHistory.getRawValue()"
                                    [ARLSurChargeByTypes]="ARLSurChargeByTypesFormValue$ | async"
                                    (someFormDirty$)="arlTableSomeFormDirty$.next($event)"
                                    [(multiselectActive)]="arlMultiselectActive"
                                    [searchQuery]="arlSearchQuery"
                                ></app-arl-table>
                            </mat-drawer-content>
                        </mat-drawer-container>
</div>
                    </mat-card>
<!--                    <mat-card class="detail-list-card" style="width: 100%; max-height: unset; padding-top: 0; border-top-left-radius: 0; border-top-right-radius: 0;">-->
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title> Titel-Zusammenfassung </mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-arl-tittle-table
                            [disabled]="DisableArlForms$ | async"
                            [arlIds]="InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue()"
                        >
                        </app-arl-tittle-table>
                    </mat-expansion-panel>
<!--                    </mat-card>-->
                    <mat-card style="width: 100%;">
                        <mat-card-content style="display: flex; justify-content: space-between; gap: 1rem;">
                            <div>
                                <span class="font-bold">Vorbewertungen <app-hint-icon hint="Dieser Wert kann den Verkaufspreis und Einkaufpreis verringern oder erhöhen. Der Ab- bzw. Zuschlag wird nicht angezeigt. Dieser Ab- bzw. Zuschlag gilt NICHT für Positionen mit überschriebenem Zuschlag"></app-hint-icon></span>
                                <div *ngFor="let form of vorbewertungsFormsVM$ | async" class="flex items-center gap-4 ml-2">
                                    <div class="font-bold grow">{{ ARLTypeEnumNames.get(form.value.arlType) }}</div>
                                    <mat-form-field style="width: 6rem">
                                        <app-number-transform-input [disabled]="form.controls.percentage.disabled" [formControl]="form.controls.percentage" [factor]="0.01"></app-number-transform-input>
                                        <span matSuffix>%</span>
                                    </mat-form-field>
                                </div>
                                <div class="font-bold" style="margin-top: 2rem">Erhöhung / Minderung <app-hint-icon hint="Dieser Wert kann den Verkaufspreis verringern oder erhöhen. Der Ab- bzw. Zuschlag wird nicht angezeigt. Dieser Ab- bzw. Zuschlag gilt NICHT für Lohn - Positionen oder Leistungen mit den Einheiten Std. oder h (hour) und Positionen mit überschriebenem Zuschlag.
"></app-hint-icon></div>
                                <div class="flex items-center gap-4 ml-2">
                                    <div class="font-bold grow">ZS</div>
                                    <mat-form-field style="width: 6rem">
                                        <app-number-transform-input [formControl]="InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge" [factor]="0.01"></app-number-transform-input>
                                        <span matSuffix>%</span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div *ngIf="this.LedgerImport$ | async as li">
                                <app-invoice-allowance-charges
                                    #allCharges
                                    [currencyCode]="li.ConsolidatedCurrencyCode"
                                    [basePrice]="(arlSumCurrencies$ | async)?.withoutAllowanceCharges.netto_number"
                                    [allowanceCharges]="InfoiceFormGroup.controls.AllowanceCharges"
                                ></app-invoice-allowance-charges>
                                <mat-divider></mat-divider>
                                <div class="flex gap-4 items-center">
                                    <div class="font-bold">Skonto</div>
                                    <div class="flex flex-col py-4">
                                        <mat-slide-toggle [formControl]="InfoiceFormGroup.controls.SkontoAvilable">anmerken</mat-slide-toggle>
                                        <mat-slide-toggle [formControl]="InfoiceFormGroup.controls.SkontoIsAllowance">abrechnen</mat-slide-toggle>
                                    </div>
                                    <mat-form-field class="small-form-field">
                                        <mat-label>Höhe</mat-label>
                                        <app-number-transform-input [formControl]="InfoiceFormGroup.controls.SkontoPercentage" [factor]="1"></app-number-transform-input>
                                        <span matSuffix>%</span>
                                    </mat-form-field>
                                    <mat-form-field class="small-form-field">
                                        <mat-label>Frist</mat-label>
                                        <app-number-transform-input [formControl]="this.InfoiceFormGroup.controls.SkontoDays" [factor]="1"></app-number-transform-input>
                                        <span matSuffix>Tage</span>
                                    </mat-form-field>
                                    <p class="font-bold skonto-sum">{{ (arlSumCurrencies$ | async)?.withAllowanceCharges.netto_number | currency: li.ConsolidatedCurrencyCode }}</p>
                                </div>
                                <mat-divider></mat-divider>
                                <button class="my-4" mat-raised-button [disabled]="InfoiceFormGroup.controls.AllowanceCharges.disabled" (click)="allCharges.add()">Zu-/Abschlag hinzufügen</button>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <!--                    <mat-expansion-panel>-->
                    <!--                        <mat-expansion-panel-header>Zu-/Abschläge</mat-expansion-panel-header>-->
                    <!--&lt;!&ndash;                        <app-allowance-charges-list [AllowanceCharges]="InfoiceFormGroup.controls.AllowanceCharges.value" (AllowanceChargesChange)="InfoiceFormGroup.controls.AllowanceCharges.setValue($event)"></app-allowance-charges-list>&ndash;&gt;-->
                    <!--                        <app-invoice-allowance-charges [basePrice]="(sumNetto$ | async)?.netto_number" [allowanceCharges]="InfoiceFormGroup.controls.AllowanceCharges"></app-invoice-allowance-charges>-->
                    <!--                    </mat-expansion-panel>-->
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title> Umsatzsteuer </mat-panel-title>
                            <mat-panel-description> Steuern für alle Positionen anpassen </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="flex justify-between gap-4 items-center">
                            <mat-form-field>
                                <mat-select placeholder="Steuern in %" [formControl]="InfoiceFormGroup.controls.TaxTypeId">
                                    <mat-option *ngFor="let option of taxOptions$ | async" [value]="option.Id">
                                        {{ option.optionLabel }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button
                                app-button
                                [Disabled]="!InfoiceFormGroup.getRawValue().TaxTypeId || (!enableButtonAlleUeberschreiben && (allArlsAlreadyFaveTaxType$ | async)) || !InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue()?.length || (DisableAllChanges$ | async)"
                                (click)="setAllTax(InfoiceFormGroup.getRawValue().TaxTypeId)"
                            >
                                alle überschreiben
                            </button>
                        </div>
                    </mat-expansion-panel>
                    <mat-card style="width: 100%; max-height: unset; box-sizing: border-box" class="p-0" *ngIf="showPartialInvoiceList$ | async">
                        <mat-card-header class="card-header">
                            <fa-icon matCardAvatar [icon]="BookingPositionMetaIcon"></fa-icon>
                            <h3 mat-card-title>Rechnungsaufstellung</h3>
<!--                            <button [disabled]="exportedFromGaeb"  style="margin-left: auto" *ngIf="PS.Has$(PS.Permissions.CreateLedgerImports) | async" app-round-button (click)="partialInvoiceTable.onAddArl()" [Disabled]="DisableForms$ | async" matTooltip="Abr.-Pos. hinzufügen">-->
<!--                                <app-double-icon Icon="money-bill" Icon2="plus"></app-double-icon>-->
<!--                            </button>-->
                            <mat-slide-toggle class="mr-4 ml-auto" [formControl]="InfoiceFormGroup.controls.InvoiceItemTableStartOnNewPage">
                                auf neuer Seite starten
                            </mat-slide-toggle>
                        </mat-card-header>
                        <div class="scroll-wrapper">
                            <app-ledger-import-invoice-item-table [invoiceItems]="(LedgerImport$ | async)?.InvoiceItems"></app-ledger-import-invoice-item-table>
                        </div>
                    </mat-card>
                    <mat-card style="width: 100%; max-height: unset; box-sizing: border-box" class="p-0" *ngIf="showPartialInvoiceList$ | async">
                        <mat-card-header class="card-header">
<!--                            <fa-icon matCardAvatar [icon]="BusinessVolumeI"></fa-icon>-->
                            <h3 mat-card-title>Zahlungsaufstellung</h3>
                            <button (click)="syncPaymentClick()" [Disabled]="DisableArlForms$ | async" [IsLoading]="ls.IsLoading$ | async" app-round-button class="m-2" matTooltip="Zahlungen aus den Stammdaten aktualisieren"><fa-icon icon="sync"></fa-icon></button>
                            <button (click)="resetPaymentClick()" [IsLoading]="ls.IsLoading$ | async" app-round-button class="m-2"  matTooltip="Zahlungen zurücksetzen" *ngIf="InfoiceFormGroup.controls.PaymentItems.dirty"><fa-icon icon="redo"></fa-icon></button>
                        </mat-card-header>
                        <div class="scroll-wrapper">
                            <app-ledger-import-payment-item-table [paymentItems]="InfoiceFormGroup.controls.PaymentItems.getRawValue()"></app-ledger-import-payment-item-table>
                        </div>
                    </mat-card>

                <mat-expansion-panel class="w-full" *ngIf="isLuksch$ | async">
                    <mat-expansion-panel-header>
                        <mat-panel-title> Prüffristen </mat-panel-title>
                        <mat-panel-description> Prüffristen, Skonto </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-textarea [Fill]="true" Key="Prüffristen" [Value]="InfoiceFormGroup.controls.ReviewPeriodText" class="pl-4 pt-4"></app-textarea>
                    <app-textarea [Fill]="true" Key="Skonto" [Value]="InfoiceFormGroup.controls.SkontoPeriodText" class="pl-4 pt-4"></app-textarea>

                </mat-expansion-panel>
                <!--                    <mat-card class="basis-md">-->
                <!--                        <app-textarea [Fill]="true" Key="Prüffristen" [Value]="InfoiceFormGroup.controls.ReviewPeriodText" class="pl-4 pt-4"></app-textarea>-->
                <!--                    </mat-card>-->

                <!--                    <mat-card class="basis-md">-->
                <!--                        <app-textarea [Fill]="true" Key="Skonto" [Value]="InfoiceFormGroup.controls.SkontoPeriodText" class="pl-4 pt-4"></app-textarea>-->
                <!--                    </mat-card>-->
                <mat-card class="w-full">

                    <div #wrapperBottomFirst class="textarea-with-template-button">
                        <mat-slide-toggle style="margin: 0 1rem; float: right" [disabled]="DisableArlForms$ | async" [formControl]="InfoiceFormGroup.controls.ShowTextBottomFirst">Zusatztext unter Buchungstabelle</mat-slide-toggle>
                        <app-textarea  [Fill]="true" Key="Erster Text unter Buchungstabelle" [Value]="InfoiceFormGroup.controls.TextBottomFirst" class="pl-4 pt-4"></app-textarea>
                        <button style="margin-top: 1rem" class="template-button" app-round-button
                                [disabled]="DisableArlForms$ | async"
                                (mousedown)="$event.preventDefault()"
                                (click)="insertTemplate(InfoiceFormGroup.controls.TextBottomFirst, wrapperBottomFirst.querySelector('textarea'))"
                                matTooltip="Vorlage einfügen">
                            <fa-icon icon="file-lines"></fa-icon>
                        </button>
                    </div>

                </mat-card>

                <mat-card class="w-full">

                    <div #wrapperBottom class="textarea-with-template-button">
                        <app-textarea [Fill]="true" Key="Text unter Buchungstabelle" [Value]="InfoiceFormGroup.controls.TextBottom" class="pl-4 pt-4"></app-textarea>
                        <button class="template-button" app-round-button
                                (mousedown)="$event.preventDefault()"
                                (click)="insertTemplate(InfoiceFormGroup.controls.TextBottom, wrapperBottom.querySelector('textarea'))"
                                matTooltip="Vorlage einfügen">
                            <fa-icon icon="file-lines"></fa-icon>
                        </button>
                    </div>
                </mat-card>
                <mat-expansion-panel class="w-full">
                    <mat-expansion-panel-header>
                        <mat-panel-title> Fußnote </mat-panel-title>
                        <mat-panel-description> Steuernummer, Bankverbindung </mat-panel-description>
                    </mat-expansion-panel-header>
                    <app-detail-list-template [Inline]="true" [Editing]="true" [Data]="FooterFormData"></app-detail-list-template>
                </mat-expansion-panel>
<!--    </div>-->
            </mat-card-content>
        </mat-card>
        <!--Der container in des app-editors-->
        <mat-card class="grow app-editor-wrapper p-2" *ngIf="previewCard === 'pdf'">
            <!--        <mat-card-header>-->
            <div>
<!--                <div class="mat-card-title">-->
<!--                    <span class="name">-->
<!--                        <span *ngIf="(LedgerImport$ | async).PartialInvoiceCounter as count">{{ count }}. </span>-->
<!--                        <span>{{ LedgerImportDocTypeName$ | async }}</span>-->
<!--                    </span>-->
<!--                    <button mat-icon-button (click)="previewCard = null"><fa-icon icon="times"></fa-icon></button>-->
<!--                </div>-->
                <div class="mat-card-subtitle" *ngIf="SfdtIsDirty$ | async">
                    <span><fa-icon icon="exclamation-triangle"></fa-icon> Das angezeigte Dokument entspricht nicht dem Original. Es wurde eine Veränderung an den Positionen vorgenommen. Bitte prüfen.</span>
                </div>
            </div>
            <div class="flex gap-2 pb-4 items-center">
                <button app-round-button [Disabled]="livePreview$ | async" (click)="triggerPreview$.next();"><fa-icon icon="arrows-rotate"></fa-icon></button>
                <mat-slide-toggle [checked]="livePreview$ | async" (change)="livePreview$.next($event.checked)">Live Vorschau</mat-slide-toggle>
                <button class="ml-auto" mat-icon-button (click)="previewCard = null"><fa-icon icon="times"></fa-icon></button>
            </div>
            <mat-progress-bar style="margin-top: -4px" *ngIf="previewPdfIsLoading$ | async" mode="indeterminate"></mat-progress-bar>

<!--                <iframe #previewIframe *ngIf="pdfPreview$ | async as pdf" [src]="pdf" style="height: 100%"></iframe>-->
                <object *ngIf="pdfPreview$ | async as pdf" type="application/pdf" [data]="pdf" style="height: 100%"></object>
        </mat-card>
        <mat-card class="grow app-editor-wrapper p-2" *ngIf="previewCard === 'calculation'">
            <div class="mat-card-title">
                <span class="name"> Kalkulation </span>
                <button mat-icon-button (click)="previewCard = null"><fa-icon icon="times"></fa-icon></button>
            </div>
            <app-invoice-calculation
                class="h-full"
                [disabled]="DisableArlForms$ | async"
                [arls]="(InvoiceFormGroupRawValues$ | async).AccountsReceivableLedgerIds"
                [lohnPreCharge]="lohnPreCharge$ | async"
                [aRLCalculationPreChargeByTypes]="(InvoiceFormGroupRawValues$ | async).ARLCalculationPreChargeByTypes"
                [allowanceCharges]="(InvoiceFormGroupRawValues$ | async).AllowanceCharges"
                [globalPreChargePercent]="(InvoiceFormGroupRawValues$ | async).ARLCalculationGlobalPreCharge"
                [SkontoAllowancePercent]="SkontoAllowancePercent$ | async"
                [nkPercent]="(InvoiceFormGroupRawValues$ | async).NebenKostenPercent"
                (nkPercentChange)="InfoiceFormGroup.controls.NebenKostenPercent.setValue($event); InfoiceFormGroup.controls.NebenKostenPercent.markAsDirty()"
                [partieStd]="(InvoiceFormGroupRawValues$ | async).PartieStd"
                (partieStdChange)="partieStdChange($event)"
                [lvCalculation]="isLvCalculated$ | async"
                [lvARLGlobalSurchargesByTypes]="InfoiceFormGroup.controls.ARLSurChargeByTypes.getRawValue()"
                (lvARLGlobalSurchargesByTypesChange)="lvARLGlobalSurchargesByTypesChange($event)"
                [lvSurchargeForOther]="nkLvCalculationsurchargeNotSalary$ | async"

            ></app-invoice-calculation>
        </mat-card>
    </div>
</div>
<ng-template #invoiceNumberInput>
    <mat-form-field style="width: 100%;">
        <mat-label>{{LedgerImportDocTypeName$.value + 'snummer/ -bezeichnung'}}</mat-label>
        <input matInput [formControl]="InfoiceFormGroup.controls.ConsolidatedInvoiceId">
        <mat-hint *ngIf="!InfoiceFormGroup.controls.ConsolidatedInvoiceId.invalid">
            {{ (consolidatedInvoiceIdValidatorPending$ | async)
            ? 'Verfügbarkeit wird geprüft'
            : (LedgerImportDocTypeName$.value + 'snummer/ -bezeichnung') + ' ist verfügbar' }}
        </mat-hint>
        <mat-error class="consolidated-invoice-id-error" *ngIf="InfoiceFormGroup.controls.ConsolidatedInvoiceId.hasError('consolidatedInvoiceIdNotAvailable')">
            {{ getInvoicenumerErrorMessage(InfoiceFormGroup.controls.ConsolidatedInvoiceId) }}
        </mat-error>
    </mat-form-field>
</ng-template>
